import { useAtomValue } from "jotai";
import { experimentsAtom } from "../../store";
import type { Experiment } from "../../constants/experiments";

export const useExperiment = (experiment: Experiment) => {
  const allExperiments = useAtomValue(experimentsAtom);
  return allExperiments.get(experiment);
};
